(() => {
  const dock = document.getElementById('ca-mobile-tools');
  if (!dock) return;
  const place = () => {
    for (const id of ['smile-ui-lite-launcher-frame-container', 'jotform-agent-preview-root']) {
      const widget = document.getElementById(id);
      if (widget && widget.parentElement !== dock) dock.append(widget);
    }
  };
  place();
  new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
})();
